"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var CollapsibleContainerSlotLocalTheme = function CollapsibleContainerSlotLocalTheme(theme) {
  return {
    appearance: {
      primary: {
        backgroundColor: 'transparent',
        inverse: {
          backgroundColor: "linear-gradient(".concat(theme.color.gradient1["default"], ")")
        }
      },
      secondary: {
        backgroundColor: theme.color.monochrome2["default"],
        inverse: {
          backgroundColor: theme.inverseColor.monochrome1["default"]
        }
      }
    }
  };
};
var _default = CollapsibleContainerSlotLocalTheme;
exports["default"] = _default;
//# sourceMappingURL=CollapsibleContainerSlot.theme.js.map